import React from 'react';
import { toastError, toastSuccess } from 'bench-internal-theme';
import { useMutation } from '@apollo/client';
import { APPLY_RULES } from './mutations';

const ApplyRules = (props: { clientId: string }) => {
  const { clientId } = props;

  const [applyRules, { loading }] = useMutation(APPLY_RULES, {
    onCompleted: ({ applyClientRules }) => {
      toastSuccess(`${JSON.stringify(applyClientRules.message)}`);
    },
    onError: error => {
      toastError(`Error occurred when applying client rules: ${error}`);
    },
  });

  const applyClientRules = () => {
    return applyRules({ variables: { clientId: clientId } });
  };

  return (
    <button className="bl-button new-button" onClick={applyClientRules}>
      {loading ? 'Applying...' : 'Apply Rules'}
    </button>
  );
};

export default ApplyRules;
